<template>
	<div>
		<header>
			<h1>ID Checks</h1>
			<div>
				<ul>
					<li v-if="$can('idCheck.create')"><router-link
						:to="{name: 'clients.create', query: {service: 'idChecks'}}"
						class="button button--primary--small">Order ID Checks</router-link></li>
				</ul>
			</div>
		</header>
		<div>
			<div class="section">
				<loader v-if="!loaded"/>
				<template v-if="loaded">
					<table-filter :filters="filters"/>
					<div v-if="!items.length" class="nothing-to-see-here">
						<p>Nothing to display.</p>
					</div>
					<v-table v-if="items.length" :loading="gettingModels">
						<thead>
							<tr>
								<th align="left">Client</th>
								<th align="left">Client Reference</th>
								<th align="center">Status</th>
								<th align="center">Result</th>
								<th align="center">Documents</th>
							</tr>
						</thead>
						<tfoot>
							<tr>
								<th align="left">Client</th>
								<th align="left">Client Reference</th>
								<th align="center">Status</th>
								<th align="center">Result</th>
								<th align="center">Documents</th>
							</tr>
						</tfoot>
						<tbody>
							<tr v-for="(item, index) in items">
								<td v-html="$present('clientName', item.client)"/>
								<td v-html="item.client.internal_reference"/>
								<td align="center">
									<status-badge :status="item.status" group="id-check"/>
								</td>
								<td align="center">
									<status-badge :status="item.status" group="id-check"/>
								</td>
								<td align="center">
									<button class="icon icon--id-check">View Documents</button>
								</td>
							</tr>
						</tbody>
					</v-table>
					<paginator :links="links" :meta="meta"/>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import Index from "../../../../components";

let index = new Index("idChecks");

export default {
	computed: {
		...index.computed(),
	},

	methods: {
		...index.actions(),
	},

	created() {
		this.getModels();
	},
};
</script>
